// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1crTX","type":"styles_type__1S4Ly","choices":"styles_choices__3YRX0"};